module.exports = __webpack_public_path__ + "img/cash-journal.037353fc.png";